import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { TamaraPaymentDepositApi } from '../../../../../api/request/wallet/deposit.js';

const Tamara = ({ amount, paymentMethod, loginTerminalId, resetAll, validateAmount }) => {
  const [form] = Form.useForm();
  const { userDetails } = useSelector((state) => state.user);
  const [isDepositLoading, setIsDepositLoading] = useState(false);

  const handleSubmit = async () => {
    if (validateAmount) {
      toast.error(validateAmount);
      return;
    }
    if (!amount) {
      toast.error('Please enter deposit amount');
      return;
    }
    setIsDepositLoading(true);
    try {
      const isWallet = loginTerminalId === 'wallet';
      const deposiParams = {
        paymentGatwayId: paymentMethod?.id,
        amount: Number(Number(amount).toFixed(2)),
        userId: userDetails?.id,
        loginTerminalId: isWallet ? 0 : loginTerminalId,
      };

      const { data } = await TamaraPaymentDepositApi(deposiParams);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        resetAll();
        const checkoutUrl = data?.data?.checkoutUrl || data?.data?.redirectUrl;
        if (checkoutUrl) {
          window.open(checkoutUrl, "_self");
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || 'Deposit failed.');
    } finally {
      setIsDepositLoading(false);
    }
  };

  return (
    <div>
      <Form form={form} layout='vertical' className='space-y-5' onFinish={handleSubmit}>
        <Form.Item
          name='conditions'
          valuePropName="checked"
          rules={[{
            validator: (_, value) =>
              value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.'))
          }]}
        >
          <Checkbox className='mt-1'>
            Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
          </Checkbox>
        </Form.Item>

        <LoadableButton
          className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
          type="submit"
          lable='Submit'
          isLoading={isDepositLoading}
          loadingLable='Adding request...'
        />
      </Form>
    </div>
  );
};

export default Tamara;